import { unspaceString } from '@grandvisionhq/utils';

const isValidPortugueseMobilePhoneNumber = (value)=>/^(\+351|00351|351)([9]{1})(6|3|2|1{1})([0-9]{7})$/.test(unspaceString(value))
;

export { isValidPortugueseMobilePhoneNumber };
//# sourceMappingURL=is-valid-portuguese-mobile-phone-number.js.map
